import TextArea from 'antd/lib/input/TextArea'
import { FooterModal } from 'components/templates'
import { useModal } from 'hooks'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const StyledSpan = styled.span``
const StyledContent = styled.div`
  padding: 24px;
  position: relative;
  label {
    margin-bottom: 12px;
  }
  textarea {
    resize: none;
    height: 120px;
  }
`
const StyledLabel = styled.div`
  margin-bottom: 12px;
`

const StyledMessage = styled.div`
  position: absolute;
  bottom: 24px;
  color: var(--color-red-106);
`

interface IProps {
  title?: string
}

export enum ActionType {
  Edit,
  Delete,
  Reload,
  Accept
}

const ReasonModal = (props: IProps) => {
  const { close } = useModal()
  const [reason, setReason] = useState('')
  const [invalid, setInvalid] = useState(false)
  const { t } = useTranslation()
  const handleOnSubmit = () => {
    if (!reason.trim()) {
      setInvalid(true)
      return
    }
    close(reason)
  }

  const handleOnChange = (e: any) => {
    setReason(e.target.value)
    setInvalid(false)
  }
  return (
    <StyledSpan className="time-slot">
      <StyledContent>
        <StyledLabel>{t('reason')}</StyledLabel>
        <TextArea
          allowClear
          status={invalid ? 'error' : ''}
          showCount
          maxLength={255}
          onChange={handleOnChange}
          value={reason}
          style={{ height: 120, marginBottom: 24 }}
        />
        {invalid && <StyledMessage>{t('message-reason-blank')}</StyledMessage>}
      </StyledContent>
      <FooterModal loading={false} onSubmit={handleOnSubmit} />
    </StyledSpan>
  )
}

export default ReasonModal
